export default __webpack_public_path__ + "static/media/social-media-small.e73674ff.svg";